export const racqFormKitIcons = {
  lockIcon: `
    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="19" viewBox="0 0 13 19" fill="none">
        <g clip-path="url(#clip0_12106_4704)">
            <path d="M4.1386 8.59602H9.28146V6.66745C9.28146 5.95762 9.03034 5.3516 8.52811 4.84937C8.02588 4.34713 7.41985 4.09602 6.71003 4.09602C6.00021 4.09602 5.39418 4.34713 4.89195 4.84937C4.38972 5.3516 4.1386 5.95762 4.1386 6.66745V8.59602ZM12.4957 9.5603V15.346C12.4957 15.6139 12.402 15.8416 12.2145 16.0291C12.027 16.2166 11.7993 16.3103 11.5315 16.3103H1.8886C1.62075 16.3103 1.39307 16.2166 1.20557 16.0291C1.01807 15.8416 0.924316 15.6139 0.924316 15.346V9.5603C0.924316 9.29245 1.01807 9.06477 1.20557 8.87727C1.39307 8.68977 1.62075 8.59602 1.8886 8.59602H2.21003V6.66745C2.21003 5.4353 2.65199 4.37727 3.53592 3.49334C4.41985 2.60941 5.47789 2.16745 6.71003 2.16745C7.94217 2.16745 9.00021 2.60941 9.88414 3.49334C10.7681 4.37727 11.21 5.4353 11.21 6.66745V8.59602H11.5315C11.7993 8.59602 12.027 8.68977 12.2145 8.87727C12.402 9.06477 12.4957 9.29245 12.4957 9.5603Z" fill="#003478"/>
        </g>
        <defs>
          <clipPath id="clip0_12106_4704">
            <rect width="11.58" height="18" fill="white" transform="matrix(1 0 0 -1 0.919922 18.8818)"/>
          </clipPath>
        </defs>
    </svg>
    `,
  select: `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M3 5L8 10L13 5" stroke="#0864BC" stroke-width="2"/>
    </svg>
      `,
};
